export function EmailJobCardCtrl (
  $scope,
  $translate,
  $uibModalInstance,
  attachments,
  blockUI,
  companyMessages,
  customer,
  invoice,
  messages,
  messengerApi,
  sendJobCard,
  templatedWording,
  type,
  vehicle
) {
  $scope.attachments     = attachments;
  $scope.block           = blockUI.instances.get('emailJobCardBlock');
  $scope.companyMessages = companyMessages;
  $scope.invoice_id      = invoice.id;
  $scope.type            = type;

  $scope.email = {
    email                 : customer.email,
    id                    : customer.id,
    invoice_id            : invoice.id,
    job_card_attachment_id: $scope.selected,
    message               : $scope.companyMessages.invoice_email_message,
    send_job_card         : sendJobCard,
    subject               : $translate.instant('JS_SPACE.EMAIL.JOB_CARD_SUBJECT', {
      name: customer.display_name,
      num : invoice.job_card_number ? ('  Job Card number ' + invoice.job_card_number) : '',
      rego: invoice.vehicle_id ? (' - ' + vehicle.plate_number) : ''
    })
  };

  // Flips lightbox after attachments have been selected
  $scope.addAttachments = function (selected) {
    $scope.email.job_card_attachment_id = selected;

    $scope.$emit('flipModal');
  };

  $scope.addTemplates = function () {
    templatedWording.addTemplate('email')
    .then(templates => {
      angular.forEach(templates, template => {
        $scope.email.message = $scope.email.message ? `${ $scope.email.message }\n\n${ template.wording }` : template.wording;
      });
    });
  };

  // Flips lightbox to allow user to select attachments
  $scope.selectAttachments = function () {
    $scope.$emit('flipModal');
  };

  $scope.send = function () {
    $scope.block.start();

    messengerApi.sendEmail($scope.email, {
      bodyParamName: 'customer',
      url          : '/invoice/email_job_card'
    })
    .then(() => {
      $uibModalInstance.close();
    })
    .catch(err => {
      messages.error(err);
    })
    .finally(() => {
      $scope.block.stop();
    });
  };
}
